import { SET_SIDEBAR_COLLAPSED } from '../../utils/constants/action-types';

export const setSidebarCollapsed = (collapsed: boolean) => ({
  type: SET_SIDEBAR_COLLAPSED,
  payload: collapsed,
});
